var render = function (_h,_vm) {var _c=_vm._c;return _c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.listeners.close()}}},[_c('i',{staticClass:"material-icons bigger red-text"},[_vm._v("close")])])}
var staticRenderFns = []

export { render, staticRenderFns }